import { render, staticRenderFns } from "./imgDialog.vue?vue&type=template&id=3faec4fe&scoped=true&"
import script from "./imgDialog.vue?vue&type=script&lang=js&"
export * from "./imgDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faec4fe",
  null
  
)

export default component.exports